export default __webpack_public_path__ + "static/media/serviceinsurance.cf5953fd.png";